<template>

  <div class="language-switcher d-flex align-items-center">
    <Icon name="globe" width="28" class="mr-1 text-primary" />
    <select @change="setLanguage($event)">
      <option v-for="locale in locales" :key="locale.code" :value="locale.code"
              :selected="browserLanguage === locale.code">{{ locale.name }} ({{ locale.code.toUpperCase() }})
      </option>
    </select>
  </div>

</template>


<script>
import {locales, setI18nLanguage, getBrowserLanguage} from "@/i18n"


export default {
  name: 'locale-changer',

  data() {
    return {
      browserLanguage: getBrowserLanguage(),
      locales
    }
  },

  methods: {
    setLanguage(event) {
      let lang = setI18nLanguage(event.target.value)
      // Save the selected language to localStorage
      localStorage.setItem('user_language', lang)
      this.$root.$emit('language-changed', lang);
      this.$store.commit('appConfig/SET_LANGUAGE', lang)
      // reload app config to get correct translation from API
      if (!this.$store.getters['isPicaThirdLevelDomain']) {
        this.$store.dispatch('appConfig/getConfig', {appName: this.$store.state.thirdLevelDomain}).then((response) => {
          this.$emit('lang-changed')
        }).catch((err) => {
          console.log(err)

        })
      } else {
        this.$store.commit('appConfig/SET_APP_CONFIG_READY')
        this.$emit('lang-changed')
      }
    }
  }
}
</script>
